/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Type d'adresse : libellé de `@mairistem/adresses` → code stocké en base
 * (`ec_acte_individu.ai_dom_type`, un entier).
 *
 * Les codes suivent l'ordre des boutons radio du composant. Ce n'est pas une
 * supposition : sur le fonds repris, `3` est le seul à corréler avec un pays
 * étranger, ce qui ancre l'échelle.
 *
 * ⚠️ Libellés recopiés en littéral, et non importés de la lib : charger
 * `@mairistem/adresses` depuis `src/constants`, largement importé, casserait
 * les tests qui n'en mockent qu'une partie — même précaution que
 * `typeComponentByTypeActe`.
 */
export const CODE_TYPE_ADRESSE: Record<string, number> = {
  Commune: 1,
  'Hors Commune': 2,
  Etranger: 3,
  Cedex: 4,
};

/** Inverse de `CODE_TYPE_ADRESSE`, pour la relecture d'un individu. */
export const LIBELLE_TYPE_ADRESSE: Record<number, string> = Object.fromEntries(
  Object.entries(CODE_TYPE_ADRESSE).map(([libelle, code]) => [code, libelle]),
);

export default CODE_TYPE_ADRESSE;
